import { createClient } from "@supabase/supabase-js";
import { SUPABASE_URL, SUPABASE_KEY, IS_LOCAL_DEVELOPMENT } from "./config.js";

// During local development a stale service worker or cache entry will happily
// serve the previous build, which makes debugging confusing. Clear both.
if (IS_LOCAL_DEVELOPMENT) {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations?.()
      .then(registrations => {
        registrations.forEach(registration => registration.unregister());
      })
      .catch(() => {});
  }
  if ("caches" in window) {
    caches
      .keys()
      .then(keys => {
        keys.forEach(key => caches.delete(key));
      })
      .catch(() => {});
  }
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true }
});
